import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { CaretDown } from "@phosphor-icons/react";

const linkClass = ({ isActive }) =>
  `relative flex items-center gap-1 px-4 py-2 text-sm font-medium tracking-wide transition-colors duration-300 ${
    isActive ? "text-slate-900 dark:text-white" : "text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white"
  }`;

const ActiveUnderline = () => (
  <motion.span layoutId="nav-underline" className="absolute left-4 right-4 -bottom-0.5 h-[2px] bg-gradient-to-r from-sky-400 to-emerald-400" />
);

const DROPDOWN_MOTION = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 8 },
  transition: { duration: 0.2 },
};

export const NavLinks = ({ navStructure, openDropdown, setOpenDropdown }) => (
  <nav className="hidden md:flex items-center gap-1">
    {navStructure.map((link) =>
      link.dropdown ? (
        <div key={link.path} className="relative" onMouseEnter={() => setOpenDropdown(link.label)} onMouseLeave={() => setOpenDropdown(null)}>
          <NavLink to={link.path} data-testid={`navbar-link-${link.label.toLowerCase()}`} className={linkClass}>
            {({ isActive }) => (
              <>
                {link.label}
                <CaretDown size={12} className={`transition-transform duration-300 ${openDropdown === link.label ? "rotate-180" : ""}`} />
                {isActive && <ActiveUnderline />}
              </>
            )}
          </NavLink>

          <AnimatePresence>
            {openDropdown === link.label && (
              <motion.div
                data-testid={`navbar-dropdown-${link.label.toLowerCase()}`}
                {...DROPDOWN_MOTION}
                className="absolute left-0 top-full pt-3 w-64"
              >
                <div className="glass rounded-2xl p-2 border border-slate-200 dark:border-white/10">
                  {link.dropdown.map((item) => (
                    <Link
                      key={item.path}
                      to={item.path}
                      data-testid={`navbar-dropdown-item-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="block px-4 py-2.5 rounded-xl text-sm text-slate-600 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white hover:bg-black/5 dark:hover:bg-white/5 transition-colors duration-200"
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ) : (
        <NavLink key={link.path} to={link.path} data-testid={`navbar-link-${link.label.toLowerCase()}`} className={linkClass}>
          {({ isActive }) => (
            <>
              {link.label}
              {isActive && <ActiveUnderline />}
            </>
          )}
        </NavLink>
      )
    )}
  </nav>
);
